/**
 * Recharge: update ATC button price when user switches one-time vs subscribe.
 * Uses a single delegated 'change' listener only – no MutationObservers.
 */
(function () {
  'use strict';

  function extractPrice(str) {
    if (!str) return 0;
    var s = String(str).replace(/[^0-9.,]/g, '').replace(',', '.');
    var n = parseFloat(s);
    return isNaN(n) ? 0 : Math.round(100 * n);
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '$0';
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
      var out = Shopify.formatMoney(cents, fmt);
      return out ? out.replace(/(\.|,)00$/, '') : out;
    }
    var a = cents / 100;
    return '$' + (cents % 100 === 0 ? a.toFixed(0) : a.toFixed(2));
  }

  function getPriceFromOption(option) {
    if (!option) return null;
    var priceEl = option.querySelector('.price-label');
    var text = priceEl ? priceEl.textContent : '';
    if (!text && option.querySelector('.rc-radio__label')) {
      text = option.querySelector('.rc-radio__label').textContent || '';
    }
    if (!text) return null;
    var match = text.match(/\$[\d,]+(\.\d{2})?/);
    return match ? extractPrice(match[0]) : extractPrice(text);
  }

  document.addEventListener('change', function (e) {
    try {
      var radio = e.target;
      if (!radio || (radio.type !== 'radio')) return;
      var rcRadio = radio.closest && radio.closest('.rc-radio');
      var rcWidget = (rcRadio && rcRadio.closest('.rc-widget')) || (rcRadio && rcRadio.closest('.recharge-subscription-widget'));
      if (!rcWidget) return;

      var section = rcWidget.closest('[data-section-type*="product"]');
      if (!section) return;

      var formWrapper = section.querySelector('[data-form-wrapper]');
      var originalPrice = 0;
      var originalCompareAtPrice = 0;
      var isOnSale = false;
      if (formWrapper) {
        var v = formWrapper.dataset.variantPrice;
        originalPrice = v ? parseInt(v, 10) : 0;
        var c = formWrapper.dataset.variantComparePrice;
        originalCompareAtPrice = c ? parseInt(c, 10) : 0;
        isOnSale = originalCompareAtPrice && originalCompareAtPrice > originalPrice;
      }

      var optionEl = rcRadio || section.querySelector('.rc-radio.rc-radio--active') || section.querySelector('.rc-radio input[type="radio"]:checked');
      if (optionEl && optionEl.tagName && optionEl.tagName !== 'DIV') optionEl = optionEl.closest('.rc-radio');
      var priceCents = getPriceFromOption(optionEl);
      if (priceCents == null) priceCents = originalPrice;
      if (priceCents === 0) return;

      var showCompare = false;
      var compareCents = null;
      if (priceCents < originalPrice) {
        showCompare = true;
        compareCents = originalPrice;
      } else if (isOnSale && priceCents < originalCompareAtPrice) {
        showCompare = true;
        compareCents = originalCompareAtPrice;
      }

      var priceHtml = formatMoney(priceCents);
      var compareHtml = compareCents != null ? formatMoney(compareCents) : null;

      section.querySelectorAll('[data-price-wrapper]').forEach(function (wrapper) {
        try {
          wrapper.querySelectorAll('[data-product-price]').forEach(function (el) {
            el.innerHTML = priceHtml;
            if (showCompare && compareHtml) el.classList.add('product__price--sale');
            else el.classList.remove('product__price--sale');
          });
          var compareEls = wrapper.querySelectorAll('[data-compare-price]');
          if (showCompare && compareHtml) {
            compareEls.forEach(function (el) {
              el.innerHTML = compareHtml;
              el.classList.remove('hidden');
              el.style.display = '';
            });
          } else {
            compareEls.forEach(function (el) { el.classList.add('hidden'); });
          }
        } catch (err) {}
      });
    } catch (err) {
      console.warn('Recharge price updater:', err);
    }
  });
})();
